import PaymentManagementCard from './PaymentManagementCard';
export default PaymentManagementCard;



// WEBPACK FOOTER //
// ./src/components/App/PaymentManagementDashboard/PaymentManagementCard/index.js